import { createContext } from 'react';

/**
 * Bridges React Router's `<Outlet context>` / `useOutletContext` pattern, which
 * has no direct TanStack equivalent. The shim `Outlet` provides this context;
 * `useOutletContext` reads it.
 */
export const OutletContext = createContext<unknown>(null);
